import React, { useEffect, useState } from "react";
import {
  Avatar,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography,
  Box,
} from "@mui/material";

export default function DepartmentUserModal({
  open,
  onClose,
  deptId,
  deptName,
}) {
  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState([]);

  useEffect(() => {
    let alive = true;
    const run = async () => {
      if (!open || !deptId) return;
      setLoading(true);
      try {
        const params = new URLSearchParams({ department_id: String(deptId) });
        const fetchList = async (path) => {
          const res = await fetch(`${path}?${params}`, {
            headers: { Accept: "application/json" },
            credentials: "same-origin",
          });
          if (!res.ok) throw new Error(`failed: ${path}`);
          const json = await res.json();
          const arr = Array.isArray(json)
            ? json
            : Array.isArray(json.users)
            ? json.users
            : [];
          return arr.map((u) => ({
            ...u,
            name: path.includes("members") ? u.full_name || u.name : u.name,
          }));
        };
        const [usersA, usersB] = await Promise.all([
          fetchList("/company/users.json"),
          fetchList("/company/members.json"),
        ]);
        // 連結して id で重複排除
        const uniq = Array.from(
          new Map([...usersA, ...usersB].map((u) => [u.id, u])).values()
        );
        if (alive) setUsers(uniq);
      } catch {
        if (alive) setUsers([]);
      } finally {
        if (alive) setLoading(false);
      }
    };
    run();
    return () => {
      alive = false;
    };
  }, [open, deptId]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="xs"
      aria-labelledby="dept-users-title"
      PaperProps={{ sx: { maxHeight: "80vh" } }}
    >
      <DialogTitle id="dept-users-title">
        {deptName ? `${deptName} のメンバー` : "メンバー一覧"}
      </DialogTitle>

      <DialogContent dividers sx={{ p: 0 }}>
        {loading ? (
          <Typography variant="body2" sx={{ p: 2 }}>
            読み込み中...
          </Typography>
        ) : users.length === 0 ? (
          <Typography variant="body2" color="text.secondary" sx={{ p: 2 }}>
            該当メンバーはいません
          </Typography>
        ) : (
          <Box sx={{ maxHeight: 300, overflowY: "auto", p: 1.5 }}>
            <List dense>
              {users.map((u) => (
                <ListItem key={u.id} disableGutters>
                  <ListItemAvatar sx={{ minWidth: 32, mr: 1 }}>
                    <Avatar
                      src={u.avatar_url}
                      sx={{ width: 24, height: 24, fontSize: 12 }}
                    >
                      {u.name?.[0]}
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText primary={u.name} sx={{ m: 0 }} />
                </ListItem>
              ))}
            </List>
          </Box>
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} variant="contained">
          閉じる
        </Button>
      </DialogActions>
    </Dialog>
  );
}
